import React, { Fragment } from "react";
import moment from "moment";
import { Helmet } from "react-helmet";
import { graphql, compose } from "react-apollo";
import CreateFranchiseMutation from "../mutations/CreateFranchise";
import FranchisesListQuery from "../queries/FranchisesList";
import FranchiseEditForm from "./FranchiseEditForm";
import { addToCache } from "../utils/queryHelpers";

class NewFranchise extends React.Component {
  handleSubmit = values => {
    const { history } = this.props;
    this.props
      .createFranchise({
        id: this.props.id,
        input: {
          ...values,
          franchiseAgreementEffectiveOn: moment(
            values.franchiseAgreementEffectiveOn
          ).format("YYYY-MM-DD"),
          franchiseAgreementExpiresOn: moment(
            values.franchiseAgreementExpiresOn
          ).format("YYYY-MM-DD")
        }
      })
      .then(() => {
        history.push("/admin/franchises");
      });
  };

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>New Franchise</title>
        </Helmet>
        <FranchiseEditForm
          onSubmit={this.handleSubmit}
          match={this.props.match}
          newFranchise
        />
      </Fragment>
    );
  }
}

const enhance = compose(
  graphql(CreateFranchiseMutation, {
    props: ({ mutate }) => ({
      createFranchise({ input }) {
        return mutate({
          variables: { input },
          update: (store, { data: { createFranchise } }) => {
            addToCache(createFranchise, store, "franchises", {
              query: FranchisesListQuery
            });
          }
        });
      }
    })
  })
);

export default enhance(NewFranchise);



// WEBPACK FOOTER //
// ./src/components/NewFranchise.js